enum RouterConstants {
    SIGN_IN = '/signin',
    SELECT = '/select',
}

export default RouterConstants;
